import type { Event } from '@patsnap/tahiti-core';
import type { FileInfo } from '../types/file-upload';

export const FileProcessingService = Symbol.for('FileProcessingService');

/**
 * 文件处理服务
 * 负责文件的两阶段处理流程：上传和识别
 * 管理文件状态和进度，通过事件通知状态变化
 */
export interface FileProcessingService {
    /**
     * 获取所有文件信息
     */
    getFiles(): Map<string, FileInfo>;

    /**
     * 获取所有文件信息（数组形式）
     */
    getAllFiles(): FileInfo[];

    /**
     * 获取正在处理的文件列表
     */
    getActiveUploads(): FileInfo[];

    /**
     * 获取失败的文件列表
     */
    getFailedUploads(): FileInfo[];

    /**
     * 是否有正在处理的文件
     */
    hasActiveUploads(): boolean;

    /**
     * 处理文件 - 执行两阶段流程
     * @param params 处理参数
     * @param params.file 要处理的文件
     * @param params.contentType 文件内容类型
     * @returns 文件ID
     */
    processFile(params: { file: File; contentType: 'DISCLOSURE' | 'CLAIM' }): Promise<string>;

    /**
     * 重试处理失败的文件
     * @param fileId 文件ID
     */
    retryFile(fileId: string): Promise<void>;

    /**
     * 移除文件
     * @param contentType 文件内容类型
     */
    removeFile(contentType: 'DISCLOSURE' | 'CLAIM'): Promise<void>;

    /**
     * 所有文件状态变化事件 - 直接提供完整的文件列表
     */
    readonly onFilesChanged: Event<FileInfo[]>;
}
